import { useAuth } from '@backoffice-frontend/authentication'
import { formatDateTime } from '@backoffice-frontend/common'
import { useErrorHandlingQuery } from '@backoffice-frontend/data-fetching'
import { Restricted } from '@backoffice-frontend/restricted'
import {
  useBackofficeLoggedInUser,
  useLoggedInUserEmail,
} from '@backoffice-frontend/user-management-ui'
import { BoumRight as Rights } from '@moia-dev/moia-token-claims'
import {
  MiniTable,
  MiniTableCopyButton,
  MiniTableRow,
  Text,
} from '@moia-dev/pace-web'
import { jwtDecode } from 'jwt-decode'
import truncate from 'lodash/truncate'
import { useTranslation } from 'react-i18next'
import { useAboutAccountViewQuery } from './AboutAccountView.hook'
import { ChangePasswordDialog } from './ChangePasswordDialog'
import { AccountLayout } from './components/AccountLayout'

export const AboutAccountView = () => {
  const { t } = useTranslation()
  const email = useLoggedInUserEmail()
  const { token, hasMFA } = useAuth()
  const idToken = token ?? ''

  const { user } = useBackofficeLoggedInUser()

  const { data, loading } = useErrorHandlingQuery(useAboutAccountViewQuery, {
    variables: {},
  })

  const organization = data?.organizations.find(
    org => org.id === user?.organizationId,
  )

  return (
    <AccountLayout header={t('authenticatedAppView_aboutAccount_header')}>
      <MiniTable>
        <MiniTableRow
          label={t('authenticatedAppView_yourOrganization')}
          content={<Text>{organization?.name ?? '-'}</Text>}
          loading={loading}
        />
        <MiniTableRow label={t('common_email_label')} content={email} />

        {user && (
          <>
            <MiniTableRow
              label={t('common_createdAt_label')}
              content={formatDateTime(user.createDate)}
            />
            <MiniTableRow
              label={t('common_modifiedAt_label')}
              content={formatDateTime(user.lastModifiedDate)}
            />
          </>
        )}

        <Restricted requiredRights={[Rights.DEV_USE_FEATURE_TOGGLES]}>
          <MiniTableRow
            label={t('authenticatedAppView_cognitoToken_header')}
            content={truncate(idToken, { length: 32 })}
            action={
              <MiniTableCopyButton
                copySuccessMessage={t('common_copied_label')}
                content={idToken}
                onClick={() => {
                  console.info(jwtDecode(idToken))
                }}
              />
            }
          />
        </Restricted>
        {hasMFA ?? (
          <MiniTableRow
            description={t('authenticatedAppView_mfaEnabled_caption')}
            label={t('authenticatedAppView_mfaEnabled_title')}
          />
        )}

        <MiniTableRow
          size="compact"
          label={t('authenticatedAppView_managePassword_label')}
          content={<ChangePasswordDialog />}
        />
      </MiniTable>
    </AccountLayout>
  )
}
